import RatingPage from '@app-studio-web/ui/pages/RatingPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../../hooks/useUpdateMode'
import { saveAnswer } from '../../../utils/onboardingStorage'

const QUESTION_KEY = 'currentSatisfaction'

const ANSWER_TEXTS = {
  '1': 'Very dissatisfied',
  '2': 'Dissatisfied',
  '3': 'Neutral',
  '4': 'Satisfied',
  '5': 'Very satisfied',
}

export default function CurrentSatisfactionPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && Object.keys(ANSWER_TEXTS).includes(value) ? value : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const rating = formData.get('rating') as string
    if (!rating) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How satisfied are you with your current space?',
      answer_key: rating,
      answer: ANSWER_TEXTS[rating as keyof typeof ANSWER_TEXTS],
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  return (
    <RatingPage
      heading={t('pages.onboarding.v1.currentSatisfaction.heading')}
      leftText={t('pages.onboarding.v1.currentSatisfaction.options.1')}
      rightText={t('pages.onboarding.v1.currentSatisfaction.options.5')}
      onSubmit={handleSubmit}
      buttonBgColor="bg-white"
      headingSize="text-3xl"
      preselectedValue={preselectedValue}
    />
  )
}
